/** Minutes as "3h 12min" — the units come from the catalogue so ja reads "3時間 12分". */
export function formatDuration(totalMinutes: number, t: (key: string) => string): string {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0) return `${minutes}${t('equipment.detail.minutes')}`;
  if (minutes === 0) return `${hours}${t('equipment.detail.hours')}`;
  return `${hours}${t('equipment.detail.hours')} ${minutes}${t('equipment.detail.minutes')}`;
}
